import React from "react";
import messages from "./messages";
import { useHistoryReports } from "../../modules/reportng";

import { FormattedMessage } from "react-intl";
import {
  RecentlyCard,
  RecentlyCardDate,
  RecentlyCardImage,
  RecentlyCardTitle,
  RecentlyCards,
  RecentlyCardsHeader,
  RecentlyCardsMore,
  RecentlyCardsTitle,
} from "../RecentlyCards";

export const RecentlyUsedSlides = () => {
  const [slides = []] = useHistoryReports();
  const objects = slides.map((x) => ({
    date: (x.date ? new Date(x.date) : new Date()).toDateString(),
    title: x.name,
    to: `/slides/${x.reportId}`,
  }));

  if (objects.length === 0) {
    return null;
  }

  return (
    <RecentlyCards>
      <RecentlyCardsHeader>
        <RecentlyCardsTitle>
          <FormattedMessage {...messages.headerLabel} />
        </RecentlyCardsTitle>
        <RecentlyCardsMore to="/slides">
          <FormattedMessage {...messages.headerMore} />
        </RecentlyCardsMore>
      </RecentlyCardsHeader>
      {objects.slice(0, 4).map((card) => (
        <RecentlyCard to={card.to} key={card.to}>
          <RecentlyCardImage />
          <RecentlyCardTitle>{card.title}</RecentlyCardTitle>
          <RecentlyCardDate>
            <FormattedMessage {...messages.dateLastOpened} />
            {card.date}
          </RecentlyCardDate>
        </RecentlyCard>
      ))}
    </RecentlyCards>
  );
};

export default RecentlyUsedSlides;
